import { render, staticRenderFns } from "./orderMineListManag.vue?vue&type=template&id=c87a9738&scoped=true"
import script from "./orderMineListManag.vue?vue&type=script&lang=js"
export * from "./orderMineListManag.vue?vue&type=script&lang=js"
import style0 from "./orderMineListManag.vue?vue&type=style&index=0&id=c87a9738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87a9738",
  null
  
)

export default component.exports